import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  currentLanguage$ = new BehaviorSubject<string>('en');
  LOCAL_KEY = "current language";
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private translate: TranslateService // Assuming ngx-translate for i18n
  ) {
    // this.loadCachedLanguage();
  }

  // loadCachedLanguage() {
  //   const cachedLanguage = localStorage.getItem(this.LOCAL_KEY);
  //   if (cachedLanguage) {
  //     this.switchLanguage(cachedLanguage);
  //   }
  // }

  getCachedLanguage() {
    return localStorage.getItem(this.LOCAL_KEY);
  }

  private languages = {
    en: { code: 'en', isRightToLeft: false, name: 'English' },
    ar: { code: 'ar', isRightToLeft: true, name: 'Arabic' },
    // Add more languages as needed
  } as const;

  //This would return the current language object based on some internal logic
  currentLanguage(language: string) {
    // Logic to retrieve the current language, e.g., from localStorage or a default setting
    const langCode: string = language;
    if (langCode in this.languages) {
      return this.languages[langCode as keyof typeof this.languages];  // Type assertion
    } else {
      return this.languages['en'];  // Fallback to default language
    }
  }
  switchLanguage(language: string): void {
    this.translate.use(language); // Switch the language using ngx-translate
    const isRtl = language === 'ar'; // Set RTL for languages like Arabic or Hebrew
    this.switchDirection(isRtl);
    this.currentLanguage$.next(language);
    localStorage.setItem(this.LOCAL_KEY, language);
  }

  private switchDirection(isRtl: boolean): void {
    if (isRtl) {
      this.document.documentElement.setAttribute('dir', 'rtl');
      this.loadRtlStyles();
    } else {
      this.document.documentElement.setAttribute('dir', 'ltr');
      this.loadLtrStyles();
    }
  }

  private loadRtlStyles(): void {
    const link = this.document.getElementById('layout-direction') as HTMLLinkElement;
    if (link) {
      link.href = './assets/css/style.rtl.css';
    }
  }

  private loadLtrStyles(): void {
    // const link = this.document.getElementById('layout-direction') as HTMLLinkElement;
    // if (link) {
    //   link.href = './assets/sass/style.scss';
    // }
  }
  loadLocalizationStyle(styleId: string, href: string): void {
    let linkElement = this.document.getElementById(styleId) as HTMLLinkElement;

    // If the link element does not exist, create it
    if (!linkElement) {
      linkElement = this.document.createElement('link');
      linkElement.id = styleId;
      linkElement.rel = 'stylesheet';
      this.document.head.appendChild(linkElement);
    }

    // Update the href attribute to load the new stylesheet
    linkElement.href = href;
  }

  /**
   * Remove the dynamically loaded style by ID
   * @param styleId - the ID of the <link> tag to remove
   */
  removeStyle(styleId: string): void {
    const linkElement = this.document.getElementById(styleId) as HTMLLinkElement;
    if (linkElement) {
      this.document.head.removeChild(linkElement);
    }
  }
}
